export const acceptPolicies = () => {
  try { localStorage.setItem('cookie-permited', 'cookie-permited') } catch(e) { return false }
}

export const policiesIsAccepted = () => {
  try { return localStorage.getItem('cookie-permited') ? true : false } catch(e) { return false }
}